import React from "react"
import { Badge } from "reactstrap"
import { matchSources } from "./labels"

// Where a match count comes from: Real (played or drawn), Calculated (format and participants) or Estimated.
export default function MatchSource({ source }) {
  const { label, color } = matchSources[source] || { label: source, color: "light" }
  return <Badge color={color}>{label}</Badge>
}
